export const getStaticMapUrlMapbox = ({
  lat,
  lng,
  zoom = 10,
  accessToken,
  size = '300x280'
}) =>
  `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/${lng},${lat},${zoom},0/${size}?access_token=${accessToken}`;

export const getStaticMapUrl = ({
  lat,
  lng,
  zoom = 10,
  apiKey,
  size = '300x280'
}) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&scale=1&zoom=${zoom}&format=png&maptype=roadmap&size=${size}&key=${apiKey}`;

export const getStaticMapUrlWoosmap = ({
  lat,
  lng,
  zoom = 10,
  apiKey,
  size = '300x280'
}) => {
  const [width, height] = size.split('x');
  return `https://api.woosmap.com/maps/static?lat=${lat}&lng=${lng}&zoom=${zoom}&width=${width}&height=${height}&key=${apiKey}`;
};

export default {
  getStaticMapUrl,
  getStaticMapUrlMapbox,
  getStaticMapUrlWoosmap
};
